import { useState } from "react";
import { useAuth } from "../lib/auth";
import TaskList from "./TaskList";
import TaskCalendar from "./TaskCalendar";
import ArrivalsTodayStrip from "../components/ArrivalsTodayStrip";
import TodayAttendanceSnapshotTiles from "../components/TodayAttendanceSnapshotTiles";
import { List, CalendarDays } from "lucide-react";

export default function MyDay() {
  const { user } = useAuth();
  const today = new Date().toLocaleDateString(undefined, { weekday:'long', month:'long', day:'numeric' });
  const [view, setView] = useState("list");
  return (
    <div className="space-y-6" data-testid="my-day">
      <div className="flex items-start justify-between gap-2 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--aii-muted)]">My Day</div>
          <h1 className="text-3xl font-semibold mt-1">{today}</h1>
          <p className="text-sm text-[color:var(--aii-text-2)] mt-2 max-w-2xl">Focus on what&apos;s yours today. Tick tasks as you finish them — your reporting manager and the Founder are notified in real time.</p>
        </div>
        <div className="inline-flex rounded-md border border-[color:var(--aii-border)] overflow-hidden">
          <button data-testid="view-list" onClick={() => setView("list")} className={`px-3 py-1.5 text-sm font-semibold flex items-center gap-1.5 ${view==="list"?"bg-brand text-white":"bg-white"}`}>
            <List size={14} /> List
          </button>
          <button data-testid="view-cal" onClick={() => setView("cal")} className={`px-3 py-1.5 text-sm font-semibold flex items-center gap-1.5 ${view==="cal"?"bg-brand text-white":"bg-white"}`}>
            <CalendarDays size={14} /> Calendar
          </button>
        </div>
      </div>
      <ArrivalsTodayStrip />
      <TodayAttendanceSnapshotTiles user={user}/>
      {view === "list" ? (
        <TaskList user={user} filterRole={user.effective_role} title="Assigned to me" />
      ) : (
        <TaskCalendar user={user} filterRole={user.effective_role} />
      )}
    </div>
  );
}
